// extracted by mini-css-extract-plugin
export var alternativeImage = "article-content-media-module--alternativeImage--21b2e";
export var contentHeading = "article-content-media-module--content-heading--ef91a";
export var image = "article-content-media-module--image--16c42";
export var imageContainer = "article-content-media-module--image-container--34a11";